import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function DonationsAdmin() {
  const [items, setItems] = useState([]);
  const [summary, setSummary] = useState({ total: 0, count: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [ds, sum] = await Promise.all([api.get("/admin/donations"), api.get("/admin/donations/summary")]);
        setItems(ds.data);
        setSummary(sum.data);
      } finally { setLoading(false); }
    })();
  }, []);

  const badgeColor = (s) => {
    if (s === "paid") return "bg-emerald_deep/10 text-emerald_deep";
    if (s === "pending") return "bg-gold/20 text-gold-600";
    return "bg-destructive/10 text-destructive";
  };

  return (
    <div data-testid="admin-donations-page">
      <div className="mb-8">
        <div className="text-[10px] uppercase tracking-[0.22em] text-gold font-semibold">Manage</div>
        <h1 className="font-serif text-4xl mt-2 text-ink">Donations</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-4 mb-8">
        <div className="rounded-3xl bg-emerald_deep text-cream p-8 relative overflow-hidden">
          <div className="absolute inset-0 pattern-girih opacity-20" />
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.22em] text-gold">Total received</div>
            <div className="font-serif text-5xl mt-3">${summary.total.toFixed(2)}</div>
          </div>
        </div>
        <div className="rounded-3xl bg-white border border-sand p-8">
          <div className="text-[10px] uppercase tracking-[0.22em] text-gold">Successful donations</div>
          <div className="font-serif text-5xl mt-3 text-ink">{summary.count}</div>
        </div>
      </div>

      {loading ? <div className="text-ink/40">Loading…</div> :
       items.length === 0 ? <div className="rounded-3xl bg-white border border-sand p-14 text-center text-ink/60">No donations yet.</div> : (
        <div className="rounded-3xl bg-white border border-sand admin-scroll admin-scroll-hint">
          <table className="w-full text-sm min-w-[800px]">
            <thead className="bg-sand/50 text-left">
              <tr>
                <th className="px-5 py-3 text-[10px] uppercase tracking-wider text-ink/60">Date</th>
                <th className="px-5 py-3 text-[10px] uppercase tracking-wider text-ink/60">Donor</th>
                <th className="px-5 py-3 text-[10px] uppercase tracking-wider text-ink/60">Designation</th>
                <th className="px-5 py-3 text-[10px] uppercase tracking-wider text-ink/60">Amount</th>
                <th className="px-5 py-3 text-[10px] uppercase tracking-wider text-ink/60">Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id} className="border-t border-sand hover:bg-cream/60">
                  <td className="px-5 py-3 text-ink/70">{new Date(it.created_at).toLocaleString()}</td>
                  <td className="px-5 py-3 text-ink">
                    <div className="font-medium">{it.donor_name || "Anonymous"}</div>
                    <div className="text-xs text-ink/50">{it.donor_email}</div>
                  </td>
                  <td className="px-5 py-3 text-ink">{it.designation}</td>
                  <td className="px-5 py-3 font-semibold text-ink">${Number(it.amount).toFixed(2)}</td>
                  <td className="px-5 py-3">
                    <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider ${badgeColor(it.payment_status)}`}>{it.payment_status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
